import { EmailInviteLanguage } from "../../autogen/bff-api";

const localStorageKey = "selected-language";

// Use string literals instead of direct enum access to prevent issues with undefined values
const languageByCode: Record<string, EmailInviteLanguage> = {
  No: "No" as EmailInviteLanguage,
  En: "En" as EmailInviteLanguage,
  no: "No" as EmailInviteLanguage,
  nb: "No" as EmailInviteLanguage,
  nn: "No" as EmailInviteLanguage,
  nb_NO: "No" as EmailInviteLanguage,
  nn_NO: "No" as EmailInviteLanguage,
  "nb-NO": "No" as EmailInviteLanguage,
  "nn-NO": "No" as EmailInviteLanguage,
  en: "En" as EmailInviteLanguage,
};

export const getPreferredLanguage = (): EmailInviteLanguage =>
  languageByCode[getStoredLanguage() ?? ""] ?? languageByCode[navigator.language] ?? EmailInviteLanguage.En;

export const getMomentLocale = (): "nb" | "en" => (getPreferredLanguage() === EmailInviteLanguage.En ? "en" : "nb");

export const setPreferredLanguage = (lang: EmailInviteLanguage) => {
  setStoredLanguage(lang);
};

const getStoredLanguage = (): string | null => {
  return localStorage.getItem(localStorageKey);
};

const setStoredLanguage = (lang: string) => {
  localStorage.setItem(localStorageKey, lang);
};
